"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepOneOnlineFirstAppointment = void 0;
const react_1 = __importStar(require("react"));
const hooks_1 = require("../../../../../store/hooks");
const reducers_1 = require("../../../../../store/reducers");
const react_native_1 = require("react-native");
const organisms_1 = require("../../../../organisms");
const atome_1 = require("../../../../atome");
const organisms_2 = require("../../../../organisms");
const User_service_1 = __importDefault(require("../../../../../services/User.service"));
const doctorslot_enum_1 = require("../../../../../enums/doctorslot.enum");
const OnlineFirstAppointment_style_1 = require("../OnlineFirstAppointment.style");
const GlobalStyles_1 = require("../../../../../helper/GlobalStyles");
const Breakpoints_1 = require("../../../../../helper/Breakpoints");
// @ts-ignore
function StepOneOnlineFirstAppointment({ navigation, setCurrentPage, onlineFirstAppointmentInfo, setOnlineFirstAppointmentInfo, }) {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [doctorSlots, setDoctorSlots] = (0, react_1.useState)([]);
    const [allDoctorSlots, setAllDoctorSlots] = (0, react_1.useState)([]);
    const [selectedSlot, setSelectedSlot] = (0, react_1.useState)();
    const [doctors, setDoctors] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [selectedDate, setSelectedDate] = (0, react_1.useState)(new Date(new Date().setHours(0, 0, 0, 0)));
    const getDoctorSlots = () => {
        setLoading(true);
        const ids = [];
        User_service_1.default.getAllDoctors().then(res => {
            if (res.error) {
                console.log(res.message);
                setLoading(false);
                return;
            }
            res.data.map((item) => ids.push(item.id));
            setDoctors(res.data);
            User_service_1.default.getMultipleDoctorOnlineSlotsBySlotType(ids, doctorslot_enum_1.DOCTOR_SLOT.FIRST_APPOINTMENT).then(res => {
                if (res.error) {
                    if (res.message.response.status === 401) {
                        dispatch((0, reducers_1.setAuth)({ isAuthenticated: false }));
                        setLoading(false);
                        navigation.navigate('Login');
                    }
                    console.log(res.message);
                }
                if (!res.data.length) {
                    setLoading(false);
                    navigation.navigate('UnavailableAppointment');
                    return;
                }
                setAllDoctorSlots(res.data);
            });
            setLoading(false);
        });
    };
    const doctorSlotsFilter = () => {
        const slotsForOnlineFirstAppointment = allDoctorSlots.filter((slot) => slot.type === 0 && slot.subtype === 1);
        setDoctorSlots(slotsForOnlineFirstAppointment);
    };
    (0, react_1.useEffect)(() => {
        getDoctorSlots();
        if (onlineFirstAppointmentInfo.selectedDate !== undefined) {
            setSelectedDate(onlineFirstAppointmentInfo.selectedDate);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        const slots = doctorSlots.filter((slot) => new Date(new Date(slot.start).setHours(0, 0, 0, 0)).getTime() ===
            new Date(selectedDate).getTime());
        setSelectedSlot(slots[0]);
    }, [selectedDate, doctorSlots]);
    const next = () => {
        if (selectedSlot) {
            setOnlineFirstAppointmentInfo({
                ...onlineFirstAppointmentInfo,
                selectedDate: selectedDate,
                doctors: doctors,
                doctorSlots: doctorSlots.filter((slot) => new Date(new Date(slot.start).setHours(0, 0, 0, 0)).getTime() -
                    selectedDate.getTime() ===
                    0),
            });
            let reducerType = {
                type: '[UPDATE]',
                payload: {
                    onlineFirstAppointmentIndex: 2,
                },
            };
            setCurrentPage(reducerType);
        }
    };
    (0, react_1.useEffect)(() => {
        doctorSlotsFilter();
    }, [allDoctorSlots]);
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(react_native_1.ScrollView, { style: [OnlineFirstAppointment_style_1.styles.scrollview] },
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_2.UserHeader, { navigation: navigation }),
            react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.container },
                react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.marginTop4px },
                    react_1.default.createElement(atome_1.Icon, { icon: "calendarWithDays", size: 70, color: "#3db384" })),
                react_1.default.createElement(react_native_1.View, { style: OnlineFirstAppointment_style_1.styles.header },
                    react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.headerTitle, OnlineFirstAppointment_style_1.styles.greenText] }, "Wann soll Ihr Online Erstgespr\u00E4ch stattfinden?")),
                doctorSlots?.length !== 0 ? (react_1.default.createElement(react_native_1.View, { style: [
                        OnlineFirstAppointment_style_1.styles.locationsContainer,
                        OnlineFirstAppointment_style_1.styles.shadowContainer,
                        OnlineFirstAppointment_style_1.styles.calendarContainer,
                    ] },
                    react_1.default.createElement(organisms_1.Calendar, { slots: doctorSlots, onChange: setSelectedDate, selectedDate: selectedDate }))) : (react_1.default.createElement(atome_1.Loading, null)),
                doctorSlots?.length !== 0 && (react_1.default.createElement(react_native_1.View, { style: [Breakpoints_1.isDesktop && GlobalStyles_1.globalStyles.row, { marginVertical: 20 }] },
                    Breakpoints_1.isDesktop && (react_1.default.createElement(react_native_1.View, { style: [OnlineFirstAppointment_style_1.styles.buttonContainer] },
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => navigation.navigate('Dashboard') },
                            react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.backButtonText] }, "\u2190 Zur\u00FCck")))),
                    react_1.default.createElement(react_native_1.View, { style: [
                            OnlineFirstAppointment_style_1.styles.buttonContainer,
                            Breakpoints_1.isDesktop && { marginLeft: 370 },
                        ] },
                        react_1.default.createElement(react_native_1.Pressable, { style: [
                                OnlineFirstAppointment_style_1.styles.buttonWeiter,
                                !selectedDate && OnlineFirstAppointment_style_1.styles.disabledButton,
                            ], disabled: (!selectedDate && !selectedSlot) || doctorSlots.length === 0, onPress: next },
                            react_1.default.createElement(atome_1.Text, { style: [OnlineFirstAppointment_style_1.styles.buttonTextWeiter] }, "Weiter")))))))));
}
exports.StepOneOnlineFirstAppointment = StepOneOnlineFirstAppointment;
